enum ConditionTypeEnum {
  AND = 'and',
  OR = 'or',
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  NOT_EMPTY = 'notEmpty',
}

export default ConditionTypeEnum;
